"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureUpdateSubscription = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Unsubscribe = _interopRequireDefault(require("./Unsubscribe"));
var _Resubscribe = _interopRequireDefault(require("./Resubscribe"));
var _jsxRuntime = require("react/jsx-runtime");
const UpdateSubscription = _ref => {
  let {
    customCancellationReasons,
    skipAvailableDowngradesStep,
    skipAvailableFreeExtensionStep
  } = _ref;
  const {
    updateSubscription: {
      action
    }
  } = (0, _reactRedux.useSelector)(state => state.popupManager);
  if (action === 'unsubscribe') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Unsubscribe.default, {
      customCancellationReasons: customCancellationReasons,
      skipAvailableDowngradesStep: skipAvailableDowngradesStep,
      skipAvailableFreeExtensionStep: skipAvailableFreeExtensionStep
    });
  }
  if (action === 'resubscribe') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Resubscribe.default, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
exports.PureUpdateSubscription = UpdateSubscription;
UpdateSubscription.propTypes = {
  customCancellationReasons: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })),
  skipAvailableDowngradesStep: _propTypes.default.bool,
  skipAvailableFreeExtensionStep: _propTypes.default.bool
};
UpdateSubscription.defaultProps = {
  customCancellationReasons: null,
  skipAvailableDowngradesStep: false,
  skipAvailableFreeExtensionStep: false
};
var _default = exports.default = UpdateSubscription;